<template>
  <span :class="{ active: isAnimated }" class="bouton-copier" @click="copyText">
    <svg-icon
      aria-label="Copier"
      class="icon-copier svg-icon-big mr-0 mt-0"
      icon-name="icon-copier"
    ></svg-icon>
    <svg-icon
      aria-label="Succès"
      class="icon-copier-ok svg-icon-big mr-0 mt-0"
      icon-name="icon-copier-ok"
    ></svg-icon>
  </span>
</template>

<script>
export default {
  name: 'BoutonCopier',
  props: { content: { type: Object, required: true } },
  data() {
    return {
      isAnimated: false,
    };
  },
  methods: {
    copyText() {
      try {
        const self = this;
        const successful = navigator.clipboard
          ? navigator.clipboard.writeText(this.content.textToCopy)
          : '';
        this.isAnimated = !!successful;
        setTimeout(function () {
          self.isAnimated = false;
        }, 3000);
      } catch (err) {
        console.error('Impossible de copier le texte.');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.bouton-copier {
  position: relative;
  display: block;
  width: 28px;
  height: 28px;
  cursor: pointer;
}

.icon-copier {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 36px;
  height: 36px;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  -webkit-transform: translate(-50%, -50%) scale(1);
  transform: translate(-50%, -50%) scale(1);
  opacity: 1;
}

.icon-copier-ok {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 60px;
  height: 60px;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  -webkit-transform: translate(-50%, -50%) scale(0.5);
  transform: translate(-50%, -50%) scale(0.5);
  opacity: 0;
}

.bouton-copier.active .icon-copier-ok {
  animation: fadein 3s;
}

.bouton-copier.active .icon-copier {
  animation: fadeout 3s;
}

@keyframes fadeout {
  10% {
    opacity: 0;
  }
  90% {
    opacity: 0;
  }
}

@keyframes fadein {
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
}
</style>
